module.exports = __webpack_public_path__ + "static/media/proWithGyro.d4790a7f.png";